export default () => ({
  admin: {}
})
